import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

import { renderInstructorPage } from './-route-wrappers';

const Bookings = lazyRouteComponent(() => import('@/_instructor/on-demand-tutoring/bookings'));

export const Route = createFileRoute('/_instructor/instructor/on-demand-tutoring/bookings')({
  component: () => renderInstructorPage(Bookings),
});
